import { UUID } from '@litlingo/client';
import useRequestMutation from 'hooks/client/useMutation';
import type { MutationResponse, RequestTypes } from 'hooks/types/client';

type UsePushInvestigationToEpiq = () => Omit<
  MutationResponse<'investigations.extras.pushToEpiquDiscover'>,
  'mutate' | 'mutateAsync'
> & {
  mutateAsync: (
    investigationId: UUID
  ) => Promise<RequestTypes['investigations.extras.pushToEpiquDiscover']>;
};

const usePushInvestigationToEpiq: UsePushInvestigationToEpiq = () => {
  const { mutateAsync: mutateAsyncBase, ...rest } = useRequestMutation(
    'investigations.extras.pushToEpiquDiscover',
    { successAlert: 'Investigation pushed to Epiq Discover' }
  );

  return {
    ...rest,
    mutateAsync: (investigationId) =>
      mutateAsyncBase({
        urlParams: { investigationId },
        data: {},
      }),
  };
};

export default usePushInvestigationToEpiq;
